<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title"> Government Servers </span>
    </div>
    <div class="button-group">
      <button class="primary-button" type="button" (click)="AddNew()">
        Add Government server
        <mat-icon class="btn-icon">open_in_new</mat-icon>
      </button>
    </div>
  </div>
  <form [formGroup]="govtServersForm" novalidate>
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Government Servers List</h6>
        <div class="component-actions">
          <button
            class="primary-button"
            [disabled]="isDownloading"
            (click)="downloadAllServerDetailsReport()"
            type="button"
          >
            Download Report <mat-icon class="btn-icon">download</mat-icon>
          </button>
          <app-common-search
            [initialSearchValue]="
              govtServersForm?.get('searchGovernmentServers')?.value
            "
            matTooltip="Name Of State | State Abbreviation | 1st SEO | Govt. IP1 | Port1 | Govt. IP2 | Port2 | 2nd SEO | Govt. IP3 | Port3 | Govt. IP4 | Port4"
            (searchSubmit)="onSearch($event)"
          ></app-common-search>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Name Of State</th>
              <th>State Abbreviation</th>
              <th>1st SEO</th>
              <th>Govt. IP1</th>
              <th>Port1</th>
              <th>Govt. IP2</th>
              <th>Port2</th>
              <th>2nd SEO</th>
              <th>Govt. IP3</th>
              <th>Port3</th>
              <th>Govt. IP4</th>
              <th>Port4</th>
              <th>Created By</th>
              @if (govtServersView || govtServersDelete) {
                <th class="sticky-col-right">Action</th>
              }
            </tr>
          </thead>
          @if (govServersList.length > 0) {
            <tbody>
              @for (
                item of govServersList
                  | paginate
                    : {
                        id: 'batchPaginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item?.state?.trim() || '--' }}</td>
                  <td>
                    {{ item?.stateAbbreviation?.trim() || '--' }}
                  </td>
                  <td>
                    {{ item?.stateEnable?.trim() || '--' }}
                  </td>
                  <td>
                    {{ item?.govtIp1?.trim() || '--' }}
                  </td>
                  <td>
                    {{ item?.port1 || '--' }}
                  </td>
                  <td>
                    {{ item?.govtIp2?.trim() || '--' }}
                  </td>
                  <td>
                    {{ item?.port2 || '--' }}
                  </td>
                  <td>
                    {{ item?.secondaryStateEnable?.trim() || '--' }}
                  </td>
                  <td>
                    {{ item?.govtIp3?.trim() || '--' }}
                  </td>
                  <td>
                    {{ item?.port3 || '--' }}
                  </td>
                  <td>
                    {{ item?.govtIp4?.trim() || '--' }}
                  </td>
                  <td>
                    {{ item?.port4 || '--' }}
                  </td>
                  <td>
                    {{ item?.createdBy?.fullName || '--' }}
                  </td>
                  @if (govtServersView || govtServersDelete) {
                    <td class="sticky-col-right">
                      <div class="action-buttons">
                        @if (govtServersView) {
                          <button
                            class="primary-button view-button"
                            (click)="viewState(item._id)"
                            type="button"
                          >
                            <mat-icon class="btn-icon">visibility</mat-icon>
                          </button>
                        }
                        @if (govtServersDelete) {
                          <button
                            class="primary-button delete-button"
                            (click)="deleteState(item._id)"
                            type="button"
                          >
                            <mat-icon class="btn-icon">delete</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  }
                </tr>
              }
            </tbody>
          }
          @if (govServersList.length === 0) {
            <tbody>
              <tr>
                <td colspan="14">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        @if (govServersList.length > 0) {
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size"
            [currentPage]="page"
            [totalPages]="totalLength"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  </form>
</div>
